const CivilWordData = [
  {
    id: 1,
    title: "Tiles/Stones Replacement",
    image: "/assets/CivilWork/Tiles:Stones Replacement.png",
    image2: "/assets/CivilWork/Tiles:Stones Replacement1.jpg",
    image3: "/assets/CivilWork/Tiles:Stones Replacement2.jpg",
    shortDescription: "Upgrade your space with new tiles and stones.",
    description:
      "Our Tiles/Stones Replacement service is designed to refresh the look and functionality of your floors and walls. Whether it's a damaged tile or outdated stonework, our skilled team ensures precise removal and installation of high-quality materials. With a range of options, you can choose the perfect design to enhance your space.",
    description1:
      "We prioritize precision and cleanliness, ensuring that the replacement process is smooth and mess-free. Our team helps you select the best materials based on your style and durability needs. From small repairs to complete overhauls, we handle every project with professionalism.",
    description2:
      "Our service includes grout replacement, surface preparation, and seamless installation to ensure longevity and aesthetics. Trust us to deliver a transformation that adds value and beauty to your home or office.",
    benefits: [
      "Seamless tile and stone replacement.",
      "Wide range of design options.",
      "Durable and high-quality materials.",
      "Mess-free and precise installation.",
      "Professional and experienced team.",
      "Increases property value and aesthetics.",
    ],
  },
  {
    id: 2,
    title: "Kitchen/Bathroom Remodeling",
    image: "/assets/CivilWork/Kitchen:Bathroom Remodeling.avif",
    image2: "/assets/CivilWork/Kitchen:Bathroom Remodeling2.jpg",
    image3: "/assets/CivilWork/Kitchen:Bathroom Remodeling3.webp",
    shortDescription:
      "Transform your kitchen or bathroom into a modern masterpiece.",
    description:
      "Our Kitchen/Bathroom Remodeling service is tailored to create functional and stylish spaces. Whether it's a complete renovation or minor upgrades, we work closely with you to design and execute the perfect plan. From cabinets and countertops to tiles and fixtures, we handle everything with precision.",
    description1:
      "We focus on delivering high-quality finishes and efficient layouts that maximize space. Our team uses premium materials and innovative designs to ensure your kitchen or bathroom is both beautiful and practical. We also offer customization options to match your style preferences.",
    description2:
      "Our service includes demolition, electrical and plumbing work, installation of fixtures, and finishing touches. With years of experience, we guarantee a seamless remodeling experience that brings your vision to life.",
    benefits: [
      "Stylish and functional designs.",
      "High-quality materials and finishes.",
      "Customized solutions to fit your needs.",
      "Comprehensive remodeling services.",
      "Professional and experienced team.",
      "Adds value to your home.",
    ],
  },
  {
    id: 3,
    title: "Replastering",
    image: "/assets/CivilWork/Replastering1.png",
    image2: "/assets/CivilWork/Replastering2.webp",
    image3: "/assets/CivilWork/Replastering3.jpg",
    shortDescription:
      "Revive your walls with our professional replastering services.",
    description:
      "Our Replastering service is designed to restore the beauty and integrity of your walls and ceilings. Whether it's damage, wear, or uneven surfaces, our team ensures a smooth and durable finish. With attention to detail, we prepare the surfaces to achieve flawless results.",
    description1:
      "We use high-quality plaster and advanced techniques to ensure longevity and a polished appearance. Our experts work efficiently to minimize disruption, delivering a hassle-free experience. Replastering is the perfect solution to give your space a fresh and modern look.",
    description2:
      "Our service includes surface preparation, crack repair, and application of plaster for a seamless finish. We also provide advice on painting and maintenance to ensure lasting results. Trust us to transform your walls into stunning focal points.",
    benefits: [
      "Smooth and durable wall finishes.",
      "Repairs damage and uneven surfaces.",
      "High-quality plaster materials.",
      "Efficient and mess-free process.",
      "Professional craftsmanship.",
      "Enhances the aesthetics of your space.",
    ],
  },
  {
    id: 4,
    title: "Crack Filling",
    image: "/assets/CivilWork/Crack Filling.webp",
    image2: "/assets/CivilWork/Crack Filling1.jpg",
    image3: "/assets/CivilWork/Crack Filling3.jpeg",
    shortDescription: "Seal and protect your walls with expert crack filling.",
    description:
      "Our Crack Filling service ensures that wall and ceiling cracks are expertly sealed to prevent further damage. Using premium materials, we restore the structural integrity and appearance of your surfaces. Whether it's small cracks or larger issues, we handle them with precision.",
    description1:
      "We focus on providing a smooth and long-lasting repair by using advanced fillers and techniques. Our team ensures that the filled cracks blend seamlessly with the surrounding area, maintaining the aesthetic appeal of your space.",
    description2:
      "Our service includes surface cleaning, crack filling, and finishing touches to ensure a flawless result. We also offer preventive solutions to minimize future cracking. Trust our team for reliable and professional crack filling services.",
    benefits: [
      "Seals cracks to prevent further damage.",
      "Restores wall and ceiling integrity.",
      "Long-lasting and smooth finishes.",
      "Advanced materials and techniques.",
      "Professional and reliable service.",
      "Maintains aesthetic appeal.",
    ],
  },
];

export default CivilWordData;
